var map = {
	"./": [
		82995,
		9
	],
	"./config": [
		55490,
		3
	],
	"./config.json": [
		55490,
		3
	],
	"./index": [
		82995,
		9
	],
	"./index.js": [
		82995,
		9
	]
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var ids = map[req], id = ids[0];
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 93361;
module.exports = webpackAsyncContext;